import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ScholarshipApiService } from '../../core/api-services/scholarship-api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Scholarship } from '../../core/models/scholarship';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class HomeComponent implements OnInit {
  private readonly scholarshipService = inject(ScholarshipApiService);
  private readonly sanitizer = inject(DomSanitizer);

  /** three randomly selected scholarships to feature on the home page */
  featured$!: Observable<Scholarship[]>;

  ngOnInit(): void {
    // The public catalogue only shows scholarships that are still accepting
    // applications.
    this.featured$ = this.scholarshipService.getScholarships(true).pipe(
      map(list => this.pickRandom(list, 3))
    );
  }

  /** default banner used when scholarship doesn't provide one */

  /** return a SafeHtml version of arbitrary markup so that it can be bound with innerHTML */
  sanitize(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html || '');
  }
  //private readonly defaultImage = 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60';

  private readonly defaultImage = 'https://images.unsplash.com/photo-1611348586755-53860f7ae57a?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';

  /** return an image URL for the card; fall back to placeholder */
  getImageUrl(s: Scholarship): string {
    return s.imageUrl || this.defaultImage;
  }

  /** utility to return `count` items randomly picked from the provided array */
  private pickRandom<T>(arr: T[], count: number): T[] {
    const copy = [...arr];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy.slice(0, count);
  }
}